export const homeSectionTitle = 'Adrian Stelmaszczyk';
export const homeSectionSubtitle = 'Junior Full Stack Developer';
export const homeSectionDescription = 'I am a highly motivated Full Stack Developer based in Warsaw, who is passionate and committed to my projects.';
export const buttonText = 'Say Hello!';
export const data = [
    { href: "https://linkedin.com/in/stelmaszczykadrian", iconClass: "bx bxl-linkedin" },
    { href: "https://github.com/stelmaszczykadrian", iconClass: "bx bxl-github" },
    { href: "mailto:stelmaszczykadrian@gmail.com", iconClass: "uil uil-envelope" },
];

